import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { ComponentRegistry } from "../node_modules/@slyte/component/index.js";

class ZcatComponentsComponentRegistry extends ComponentRegistry {
  constructor() {
    super();
  }
  lookups() {
    return [];
  }
  addRegistries() {
    return [
      this.$app.$slyteEditorApp.$component,
      this.$app.$lyteUiComponentAddon.$component,
      this.$app.$zcatUiComponentAddon.$component
    ];
  }

  _() {
    _;
  }
}

ZcatComponentsComponentRegistry._observedAttributes = [];

ZcatComponentsComponentRegistry.register({
  hash: "C_zcat-ui-component-docs_app_0",
  refHash: "app_1",
  app: true
});

export { ZcatComponentsComponentRegistry };
